const INITIAL_STATE = {
	aguardando: false,
	salvando: false,
	salvamentosPendentes: 0,
	carga: null,
	historico: []
};

export default (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case 'PRODUCAO_CARGA_SET_AGUARDANDO':
			return {
				...state,
				aguardando: action.payload
			};

		case 'PRODUCAO_CARGA_SET_SALVANDO': {
			const salvamentosPendentes = Math.max(
				0,
				state.salvamentosPendentes + (action.payload ? 1 : -1)
			);

			return {
				...state,
				salvando: salvamentosPendentes > 0,
				salvamentosPendentes
			};
		}

		case 'PRODUCAO_CARGA_CARREGADA':
			return {
				...state,
				carga: action.payload
			};

		case 'PRODUCAO_CARGA_HISTORICO_LISTADO':
			return {
				...state,
				historico: action.payload
			};

		case 'PRODUCAO_CARGA_LIMPAR':
			return {
				...state,
				carga: null,
				historico: [],
				salvando: false,
				salvamentosPendentes: 0
			};

		default:
			return state;
	}
};
